import React, { Component } from 'react'
import Fade from 'react-reveal/Fade'

class Timeline extends Component {

  render() {
    const { title, items } = this.props

    return (
      <section className='timeline' data-color="#FFFFFF">
        <div className="timeline__inner container">
          <h3 dangerouslySetInnerHTML={{ __html: title }} />
          <div className="timeline__items">
            { items.map((item, index) => (
              <div className="timeline__item" key={index}>
                <Fade bottom distance='25px'>
                  <div className="timeline__image">
                    <img src={item.image.localFile.publicURL} alt={item.title} />
                  </div>
                  <div className="timeline__content">
                    <h4>{item.title}</h4>
                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                  </div>
                </Fade>
              </div>
            )) }
          </div>
        </div>
      </section>
    )
  }
}

export default Timeline